import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

import analise from "./modules/analise";
import usuario from "./modules/usuario";
import navigation from "./modules/navigation";
import venda from "./modules/venda";
import vendas from "./modules/vendas";
import checkout from "./modules/checkout";
import products from "./modules/products";
import alertas from "./modules/alertas";

const vuexPersist = new VuexPersist({
  key: "flexcard",
  storage: localStorage,
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    analise,
    usuario,
    navigation,
    venda,
    checkout,
    products,
    vendas,
    alertas,
  },
  plugins: [vuexPersist.plugin],
});
